import React from "react";
import { useAlert } from "react-alert";
import Header from "./Header";
import Footer from "./Footer";
import $ from "jquery";
import axios from "axios";

const processEnv = {
  APP_ID: "1186442446026111",
  VERSION: "v20.0",
  APP_SECRET: "c3f01e562d17caf0265caa55fc7f2d07",
  PHONE_NUMBER_ID: "436690542856690",
  WEBHOOK_ENDPOINT: "/webhook/callback",
  WEBHOOK_VERIFICATION_TOKEN: "meatyhamhock",
  ACCESS_TOKEN:
    "EAAQ3ECiKtX8BO7SiwbG6ZBZAxSglPvG6rNJcMb254PKz8g3Vq2ZCQlclbIFrZAlmwxNjRTYVnPJqsYk2hD0O86VML7sc4sn5NFlnQeEjuxO8ZChVsZACMI8iRXWI079khYiSglveQ78cZA15n8KiPbWxjGQRFy6U5HzWImhws9FOOf0b4YTDn1ln2d2sZB8w1mokksIZD",
  BING_API_KEY: "c8ecf88023ea4e9ba062e6fbc3865f62",
  API_KEY:
    "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",
  NEWS_KEY: "pub_65110d026e5b7a35a63042281c04f977820ca",
};

var _ = require("lodash");

function Newra(props) {
  const alert = useAlert();
  function onButtonClick() {
    var number = $(".userNumber").val();
    if (!number || number.length !== 10) {
      alert.error("An issue occurred when submitting. Invalid number");
      return;
    }
    getNews()
      .then(function (response) {
        var message = _.take(
          _.map(response.data.results, ({ title, description, link }) => {
            if (!title || !description || !link) return;
            return `**${title}**\n${description}\nRead more: ${link}`;
          }),
          5
        );
        var data = getTextMessageInput(91 + number, JSON.stringify(message));

        sendMessage(data)
          .then(function (response) {
            alert.success("Success, Check your whatsapp!");
            return;
          })
          .catch(function (error) {
            console.log(error);
            alert.error("An issue occurred when sending message.");
            return;
          });
      })
      .catch(function (error) {
        console.log(error);
        alert.error("An issue occurred when submitting.");
        return;
      });
  }
  function onValueChange() {
    var number = $(".register_number").val();
    if (number.length === 10) {
      var data = JSON.stringify({
        messaging_product: "whatsapp",
        to: 91 + number,
        type: "template",
        template: { name: "welcome", language: { code: "en_US" } },
      });
      sendMessage(data)
        .then(function (response) {
          alert.success("Newra invitation send successfully");
          $(".register_number").val("");
          return;
        })
        .catch(function (error) {
          console.log(error);
          alert.error("An issue occurred when sending invitation.");
          $(".register_number").val("");
          return;
        });
      return;
    }
  }

  return (
    <>
      <Header onValueChange={onValueChange} />
      <section className="section pt-0" id="newra">
        <div class="bg-image"></div>
        <div class="bg-text">
          <h1 class="text-center mb-4">Newra</h1>
          <p class="text-center">
            Enter your number <br /> below for news bot
          </p>
          <div class="form-outline">
            <input name="number" type="number" class="userNumber" />
          </div>

          <div class="pt-1 mb-4">
            <input
              onClick={onButtonClick}
              style={{ margin: "1rem 0", color: "#fff" }}
              type="submit"
              class="btn btn-info btn-lg btn-block"
              value="Get News Now"
            />
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

function sendMessage(data) {
  var config = {
    method: "post",
    url: `https://graph.facebook.com/${processEnv.VERSION}/${processEnv.PHONE_NUMBER_ID}/messages`,
    headers: {
      Authorization: `Bearer ${processEnv.ACCESS_TOKEN}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config);
}

function getTextMessageInput(recipient, text) {
  return JSON.stringify({
    messaging_product: "whatsapp",
    preview_url: false,
    recipient_type: "individual",
    to: recipient,
    type: "text",
    text: {
      body: text,
    },
  });
}

function getNews() {
  var url = `https://newsdata.io/api/1/news?apikey=${processEnv.NEWS_KEY}&country=in&language=en `;

  return axios({
    method: "get",
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  });
}
export default Newra;
